import React, { useCallback, useContext, useEffect, useState } from 'react';
import '../workflow-editor/workflowEditor.css';

import { getWorkflowHistory } from '../../services/api-calls';

import { TenantIdContext } from '../../../../components/app/App';
import { useHistory } from 'react-router';
import { Header } from '../header/Header';
import { HistoryBuilder } from './HistoryBuilder';
import Table, { TableRow, TableCell } from '@amzn/meridian/table';
import Icon from '@amzn/meridian/icon';
import viewTokens from '@amzn/meridian-tokens/base/icon/view';
import Button from '@amzn/meridian/button';
import RevisionViewer from './RevisionViewer';

export const HistoryViewer = ({ match }) => {
  const tenantId = useContext(TenantIdContext);

  const [workflowData, setWorkflowData] = useState(null);
  const [loadedTenantId, setLoadedTenantId] = useState('');
  const [historyBuilder, setHistoryBuilder] = useState(null);
  const [viewingRevision, setViewingRevision] = useState(null);
  const history = useHistory();

  useEffect(() => {
    if (loadedTenantId && loadedTenantId !== tenantId) {
      return;
    }
    getWorkflowHistory(tenantId, match.params.id).then(response => {
      const historyResponse = response?.data;
      if (!historyResponse || !historyResponse?.activeWorkflow) {
        history.push('/workflows');
      }
      setWorkflowData(historyResponse);
      setLoadedTenantId(tenantId);
    });
  }, [match, tenantId, history, loadedTenantId]);

  useEffect(() => {
    if (!workflowData || !workflowData.activeWorkflow) {
      return;
    }
    setHistoryBuilder(new HistoryBuilder(workflowData));
  }, [workflowData]);

  const handleViewRevision = useCallback(
    idx => {
      setViewingRevision(historyBuilder.revisions[idx]);
    },
    [historyBuilder]
  );

  return (
    <div className="w-100 h-100 p-1 d-flex flex-column">
      <Header workflowData={workflowData?.activeWorkflow} currentPage="history" />
      <Table headerRows={1} showStripes={true} spacing="medium">
        <TableRow>
          <TableCell>Updated Date</TableCell>
          <TableCell>Changed By</TableCell>
          <TableCell>Updated Info</TableCell>
          <TableCell>View</TableCell>
        </TableRow>

        {historyBuilder &&
          historyBuilder.revisions.map((entry, idx) => {
            return (
              <TableRow>
                <TableCell>{new Date(entry.lastUpdatedTime * 1000).toLocaleString()}</TableCell>
                <TableCell>{entry.createdBy ? entry.createdBy : 'Unknown'}</TableCell>
                <TableCell>
                  {entry.changed.map(infoChanged => {
                    return <div>{infoChanged}</div>;
                  })}
                </TableCell>
                <TableCell>
                  <Button type="icon" onClick={() => handleViewRevision(idx)}>
                    <Icon tokens={viewTokens} />
                  </Button>
                </TableCell>
              </TableRow>
            );
          })}
      </Table>
      <RevisionViewer workflowData={viewingRevision} onClose={() => setViewingRevision(null)} />
    </div>
  );
};

export default HistoryViewer;
